export const SESSION_CREATE = 'SESSION_CREATE';
export const SESSION_SAVE = 'SESSION_SAVE';
export const PRODUCTS_SAVE = 'PRODUCTS_SAVE';
export const CARD_UPDATE_REQUEST = 'CARD_UPDATE_REQUEST';
export const SUBSCRIPTION_FETCH = 'SUBSCRIPTION_FETCH';
export const SUBSCRIPTION_SAVE = 'SUBSCRIPTION_SAVE';
export const SUBSCRIPTION_REQUEST = 'SUBSCRIPTION_REQUEST';
export const BRANDS_FETCH = 'BRANDS_FETCH';
export const BRANDS_ADD = 'BRANDS_ADD';
export const CURRENT_CARD_BRAND_SAVE = 'CURRENT_CARD_BRAND_SAVE';
export const LOADING_SHOW = 'LOADING_SHOW';
export const LOADING_HIDE = 'LOADING_HIDE';
export const MODAL_SHOW = 'MODAL_SHOW';
export const MODAL_HIDE = 'MODAL_HIDE';
export const FLASH_MESSAGE_SET = 'FLASH_MESSAGE_SET';
export const DEVICE_SET = 'DEVICE_SET';
export const PRODUCTS_FETCH = 'PRODUCTS_FETCH';
export const PRODUCT_UPDATE_REQUEST = 'PRODUCT_UPDATE_REQUEST';
export const PIX_SESSION_TOKEN_REQUEST = 'PIX_SESSION_TOKEN_REQUEST';
